<template>
  <Day day="12.12.2025">
    <div slot="page-content">
      <h3>Sunset at the Beach</h3>
      <p>
        <img src="@/assets/day12.jpeg"/>
      </p>
    </div>
  </Day>
</template>

<script>
import Day from '../Day.vue'

export default {
  name: 'Day12',
  components: {
    Day
  }
}
</script>
